import Loadable from '@/common/lazy/Loadable';
import imports from '@/routing/imports';

export const MyTicketsLoadable = Loadable({ loader: imports.mytickets, exp: Exp => Exp.MyTickets });
